import { AxiosResponse } from 'axios';

import API from '../Api';
import { getUserToken, logUserOut } from '../utils/login';
// Types.
import { MeteringPointGroup } from '../types/consumptionRates';

export const fetchMeteringPointGroups = async (dataOwnerCustomerId: number): Promise<MeteringPointGroup[]> => {
  const { bearer, content } = getUserToken();

  if (!bearer || bearer.length === 0) {
    logUserOut();
  }

  const groups: AxiosResponse<MeteringPointGroup[]> = await API({
    method: 'post',
    url: `/v1/meteringPointGroups/${dataOwnerCustomerId}/all`,
    headers: {
      Authorization: `Bearer ${bearer}`,
    },
    data: {
      content: `${content}`,
    },
  }).catch((error) => {
    if (error.response) {
      if (error.response.status === 401) {
        logUserOut();
      }
      return error.response;
    }
  });

  return groups.data;
};

export const fetchMeteringPointGroup = async (dataOwnerCustomerId: number, meteringPointGroupId: string): Promise<MeteringPointGroup> => {
  const { bearer, content } = getUserToken();

  if (!bearer || bearer.length === 0) {
    logUserOut();
  }

  const group: AxiosResponse<MeteringPointGroup> = await API({
    method: 'post',
    url: `/v1/meteringPointGroups/${dataOwnerCustomerId}/${meteringPointGroupId}`,
    headers: {
      Authorization: `Bearer ${bearer}`,
    },
    data: {
      content: `${content}`,
    },
  }).catch((error) => {
    if (error.response) {
      if (error.response.status === 401) {
        logUserOut();
      }
      return error.response;
    }
  });

  return group.data;
};

export const putMeteringPointGroup = async (
  dataOwnerCustomerId: number,
  groupName: string,
  meteringPoints: string,
  identifier?: string,
): Promise<number> => {
  const { bearer, content } = getUserToken();

  if (!bearer || bearer.length === 0) {
    logUserOut();
  }

  const parsedMeteringPoints = JSON.parse(meteringPoints);

  const group: AxiosResponse<number> = await API({
    method: 'put',
    url: `/v1/meteringPointGroups/${dataOwnerCustomerId}/${identifier ?? 'new'}`,
    headers: {
      Authorization: `Bearer ${bearer}`,
    },
    data: {
      content: `${content}`,
      identifier,
      groupName,
      meteringPoints: parsedMeteringPoints,
    },
  }).catch((error) => {
    if (error.response) {
      if (error.response.status === 401) {
        logUserOut();
      }
      return error.response;
    }
  });

  return group.status;
};

export const deleteMeteringPointGroup = async (dataOwnerCustomerId: number, meteringPointGroupId: string): Promise<number> => {
  const { bearer, content } = getUserToken();

  if (!bearer || bearer.length === 0) {
    logUserOut();
  }

  const group: AxiosResponse<number> = await API({
    method: 'delete',
    url: `/v1/meteringPointGroups/${dataOwnerCustomerId}/${meteringPointGroupId}`,
    headers: {
      Authorization: `Bearer ${bearer}`,
    },
    data: {
      content: `${content}`,
    },
  }).catch((error) => {
    if (error.response) {
      if (error.response.status === 401) {
        logUserOut();
      }
      return error.response;
    }
  });

  return group.status;
};
